import { getAreaCodes, getAppId } from "@/api/account";
import Storage from "@/utils/storage";

const app = {
  state: {
    areacodes: [],
    appId: null,
    brandId: null,
  },
  mutations: {
    SET_AREA_CODES: (state, data) => {
      state.areacodes = data.concat();
    },
    SET_APP_ID: (state, appId) => {
      state.appId = appId;
      Storage.set("appId", appId);
    },
    SET_BRAND_ID: (state, brandId) => {
      state.brandId = brandId;
      Storage.set("brandId", brandId);
    },
  },
  actions: {
    /**
     * 获取appid，调用用户中心接口需要用到
     * @param {*} param0
     * @param {*} name
     */
    getAppId({ commit }, name) {
      return new Promise((resolve, reject) => {
        getAppId(name)
          .then((res) => {
            const appId = res.data.app_id;
            const brandId = res.data.brand_id;
            commit("SET_APP_ID", appId);
            commit("SET_BRAND_ID", brandId);
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    /**
     * 获取地区码
     * @param {*} param0
     */
    getAreaCodes({ commit }) {
      return new Promise((resolve, reject) => {
        getAreaCodes()
          .then((res) => {
            const { list } = res.data;
            const areacodes = [];
            if (list) {
              list.forEach((ele) => {
                areacodes.push({
                  code: ele.split(":")[0],
                  area: ele.split(":")[1],
                  key: ele,
                });
              });
              commit("SET_AREA_CODES", areacodes);
              Storage.set("areacodes", areacodes);
              resolve();
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
};

export default app;
